import Layer from './Layer';

// 行政界
export default class Boundaries extends Layer {
    url = process.env.REACT_APP_BOUNDARIES_URL;

    constructor() {
        const id = 'boundaries';
        const layers = {
            'boundaries-pref-line': {
                type: "line",
                source: id,
                "source-layer": "pref",
                minzoom: 3,
            },
            'boundaries-city-line': {
                type: "line",
                source: id,
                "source-layer": "city",
                minzoom: 8,
            },
        };

        const paintOptions = {
            'boundaries-pref-line': {
                "line-color": "rgba(60, 60, 60, 0.8)",
                "line-width": ['interpolate',
                    ['exponential', 1.5],
                    ['zoom'],
                    2, 0.6,
                    8, 1.4
                ]
            },
            'boundaries-city-line': {
                "line-color": 'rgba(90, 90, 90, 0.8)',
                "line-width": ['interpolate',
                    ['exponential', 1.5],
                    ['zoom'],
                    2, 0.2,
                    8, 1.0
                ]
            },
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'boundaries', layers: ['boundaries-pref-line', 'boundaries-city-line'], isShow: true },
        ];

        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    async add() {
        this.map.addSource(this.id, {
            "type": "vector",
            "minzoom": 0,
            "maxzoom": 10,
            "tiles": [this.url]
        });

        Object.keys(this.layers)
            .map(x =>
                this.map.addLayer({ id: x, ...this.layers[x], paint: { ...this._paintOptions[x] } })
            );
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }
};


